var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-block"},[_c('h3',[_vm._v(" "+_vm._s(_vm.chartName)+" "),_c('span',[_vm._v(_vm._s(_vm.updated))])]),_c('div',{staticClass:"chart-box",attrs:{"id":"chart_cmnc","loading":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }